import React, { useEffect, useState } from 'react'

import { StaticImage } from 'gatsby-plugin-image'
import Button from '../../atoms/button/button'
import { graphql, navigate, useStaticQuery } from 'gatsby'
import './premios-section.scss'
import { LOCALE, LOCALE_AT } from '../../../constants/activity-constants'
import useMediaQuery from '../../../utils/useMediaQuery'
const defaultVirtualGift = [
  <StaticImage
    src="../../../assets/images/premios/virtual-gift.webp"
    alt="Premio virtual"
    height={275}
    placeholder="blurred"
    className="image  "
  />,
]

export default function PremiosSection({ id }) {
  const isMobile = useMediaQuery()
  return (
    <section className={'f-premios-section '} id={id}>
      <div className="f-premios-section__wrapper">
        <div className="f-premios-section__center section-logo flex --column">
          <ImageLogoActividad isMobile={isMobile} />
          {isMobile ? null : (
            <Button
              className="violeta-rosa"
              tag="7A"
              onClick={() => {
                navigate('/play')
              }}
            >
              <CallToActionText />
            </Button>
          )}
        </div>
        <aside className="f-premios-section__aside section-ruleta --media flex --column">
          <ActivityImageWrapper />
        </aside>
        <aside className="f-premios-section__aside section-box">
          <div className="f-premios-section__card">
            <Title />

            <PinkPhrase />
            <Phrase1 />
            <Phrase2 />
          </div>

          <PremisByCountry />
          {isMobile ? (
            <Button
              className="violeta-rosa"
              tag="7A"
              onClick={() => {
                navigate('/play')
              }}
            >
              <CallToActionText />
            </Button>
          ) : null}
        </aside>
      </div>
    </section>
  )
}

function getImagePremios() {
  return [ImagenCOL()].concat(defaultVirtualGift)
}

function ImageLogoActividad({ isMobile }) {
  const imgProps = {
    alt: 'Logo de la actividad trivia master preguntados',
    height: 462,
    placeholder: 'blurred',
    className: '',
  }

  if (isMobile) {
    return (
      <StaticImage
        src="../../../assets/images/logo-actividad.png"
        {...imgProps}
        height={198}
      />
    )
  }

  return (
    <StaticImage
      src="../../../assets/images/logo-actividad.png"
      {...imgProps}
    />
  )
}
function ShowCase() {
  const [current, setCurrent] = useState(0)
  const imagenPremios = getImagePremios()
  useEffect(() => {
    let page = 0
    let total = imagenPremios.length - 1
    let interval = 0
    if (total < 2) {
      return
    }
    const disappear_time = 1000
    const standing_time = 3000
    const dissappear = () => {
      let imagewrapper = document.querySelector('.f-premios-section__showcase')
      if (!imagewrapper) {
        return Promise.resolve()
      }
      imagewrapper.classList.add('disappear')
      return waitTime(disappear_time).then(() => {
        imagewrapper.classList.remove('disappear')
      })
    }
    const waitTime = (time = 1000) => {
      return new Promise(resolve => {
        interval = setTimeout(resolve, time)
      })
    }
    const waitToFade = () => {
      return waitTime(standing_time).then(() => {
        return dissappear()
      })
    }
    const next = () => {
      page++
      if (page > total) {
        page = 0
      }
      setCurrent(page)
      waitToFade().then(() => {
        next()
      })
    }
    waitToFade().then(() => {
      next()
    })

    return () => {
      clearInterval(interval)
    }
  }, [])
  return (
    <div className={'f-premios-section__showcase '}>
      {imagenPremios[current]}
    </div>
  )
}
function ActivityImageWrapper() {
  useEffect(() => {
    const unbinds = {}

    let do_rotation = true
    let do_shine = true
    let do_spark = true
    const random = (min, max) => {
      return Math.floor(Math.random() * (max - min + 1)) + min
    }

    const timeOutUntil = (callback, time = 1000) => {
      let id = setTimeout(callback, time)
      unbinds[id] = () => {
        clearTimeout(id)
        unbinds[id] = null
        delete unbinds[id]
      }
    }
    const fadeInRotate = (element, dist, time, callback) => {
      let ang = random(0, 360)
      let scale = random(8, 22) / 10
      element.style.transform = `rotate(${ang}deg) translate(${dist}px,${0}px) scale(${scale})`
      element.style.animation = `fade-in ${time / 1000}s ease-in-out both`
      timeOutUntil(() => {
        element.style.animation = `fade-out ${time / 1000}s ease-in-out both`
        timeOutUntil(callback, time)
      }, time)
    }

    let mainInterval = setInterval(() => {
      let rulette = document.getElementById('rulette')
      let shines = document.getElementById('shines')
      let sparks = document.getElementById('sparks')
      if (do_rotation) {
        do_rotation = false
        let ang = random(45, 360) * 5
        rulette.style.transform = `rotate(${ang}deg)`
        timeOutUntil(() => {
          rulette.style.transform = `rotate(0deg)`
          timeOutUntil(() => {
            do_rotation = true
          }, 3200)
        }, 3200)
      }
      if (do_shine) {
        do_shine = false
        fadeInRotate(shines, 160, 600, () => {
          do_shine = true
        })
      }
      if (do_spark) {
        do_spark = false
        fadeInRotate(sparks, 160, 400, () => {
          do_spark = true
        })
      }
    }, 100)

    return () => {
      clearInterval(mainInterval)
      for (let i in unbinds) {
        unbinds[i]()
      }
    }
  }, [])
  return (
    <div className="f-premios-section__media-wrapper">
      <div className="f-premios-section__media-wrapper__background">
        <div
          id="rulette"
          className={
            'f-premios-section__media-wrapper__prizes --' + LOCALE.toLowerCase()
          }
        ></div>
        <div className="f-premios-section__media-wrapper__arrow"></div>
        <div className="f-premios-section__media-wrapper__circle_logo"></div>

        <div id="shines" className="f-premios-section__media-wrapper__shines" />
        <div id="sparks" className="f-premios-section__media-wrapper__sparks" />
      </div>
    </div>
  )
}
function ImageBase() {
  const imgProps = {
    alt:
      'la ruleta que es la imagen de la actividad  trivia  master preguntados',
    height: 405,
    placeholder: 'blurred',
    className: 'image  rueda-fondo',
  }

  return (
    <div className="--baseWrapper">
      <StaticImage
        src="../../../assets/images/premios/base-premios.png"
        {...imgProps}
      />
      <i>Imágenes de referencia*</i>
    </div>
  )
}
function PremiosAbsoluteWrapper({ children }) {
  return (
    <div className="premios-wrapper">
      <div className="absolute-image ">{children}</div>
    </div>
  )
}
function PremisByCountry() {
  if (LOCALE_AT.ARGENTINA) {
    return (
      <PremiosAbsoluteWrapper>
        <PremiosAR />
      </PremiosAbsoluteWrapper>
    )
  }
  if (LOCALE_AT.CHILE) {
    return (
      <PremiosAbsoluteWrapper>
        <PremiosCL />
      </PremiosAbsoluteWrapper>
    )
  }
  if (LOCALE_AT.PARAGUAY) {
    return (
      <div className="flex" style={{ marginBottom: '3rem' }}>
        <PremiosPY />
      </div>
    )
  }
  if (LOCALE_AT.PERU) {
    return (
      <PremiosAbsoluteWrapper>
        <PremiosPE />
      </PremiosAbsoluteWrapper>
    )
  }
  return <TransitionPremios />
}
function TransitionPremios() {
  return (
    <div className="f-premios-section__stage-wrapper flex --column">
      <ShowCase />
      <ImageBase />
    </div>
  )
}
function Title() {
  const winners =
    { 'es-CL': 10, 'es-PE': 20, 'es-PY': 5, 'es-AR': 5 }[LOCALE] || 5
  return (
    <h2 className={` --big-title`}>
      Sé una de las
      <br /> {winners} ganadoras de:
    </h2>
  )
}
function PinkPhrase() {
  return null
}
function Phrase1() {
  const messageByCountry = {
    'es-CO': <> AirPods + 1 Kit de productos Nosotras</>,
    'es-CL': <> 1 Kit de productos Nosotras</>,
    'es-PE': <> ¡Un Puff de Playa Nosotras + Kit de productos Nosotras®!</>,
    'es-PY': <>¡Un espectacular Kit Nosotras®!</>,
    'es-AR': <>¡Un espectacular Kit Nosotras®!</>,
  }[LOCALE] || <> 1 Kit de productos Nosotras</>
  return (
    <p className="--big-phrase">
      {messageByCountry}
      <br />
    </p>
  )
}
function Phrase2() {
  return null
}

function CallToActionText() {
  if (LOCALE_AT.ARGENTINA || LOCALE_AT.PARAGUAY || LOCALE_AT.URUGUAY) {
    return <>Participá ya</>
  }
  return <>¡a jugar!</>
}

function ImagenCOL() {
  const isMobile = useMediaQuery()
  const imgProps = {
    alt: 'Premios',

    placeholder: 'blurred',
    className: 'image  ',
  }
  if (isMobile) {
    return (
      <StaticImage
        src="../../../assets/images/premios/premio-col.png"
        {...imgProps}
        width={262}
        style={{ position: 'relative', bottom: '-20px' }}
      />
    )
  }

  return (
    <StaticImage
      src="../../../assets/images/premios/premio-col.png"
      {...imgProps}
      style={{ position: 'relative', bottom: '-20px' }}
      width={351}
    />
  )
}
function PremiosCL() {
  const isMobile = useMediaQuery()
  const imgProps = {
    alt: 'Premios',
    placeholder: 'blurred',
    className: 'image  ',
  }

  if (isMobile) {
    return (
      <StaticImage
        src="../../../assets/images/premios/premios-cl.png"
        {...imgProps}
        width={319}
      />
    )
  }

  return (
    <StaticImage
      src="../../../assets/images/premios/premios-cl.png"
      {...imgProps}
      width={593}
    />
  )
}
function PremiosPY() {
  const isMobile = useMediaQuery()
  const imgProps = {
    alt: 'Premios',
    placeholder: 'blurred',
    className: 'image  ',
  }

  return (
    <StaticImage
      src="../../../assets/images/premios/premios-py.png"
      {...imgProps}
      height={384}
    />
  )
}

function PremiosAR() {
  const isMobile = useMediaQuery()
  const imgProps = {
    alt: 'Premios',
    placeholder: 'blurred',
    className: 'image  ',
  }
  if (isMobile) {
    return (
      <StaticImage
        src="../../../assets/images/premios/premios-ar.png"
        {...imgProps}
        width={182}
      />
    )
  }
  return (
    <StaticImage
      src="../../../assets/images/premios/premios-ar.png"
      {...imgProps}
      height={284}
    />
  )
}
function PremiosPE() {
  const gifImg = getGif()
  const isMobile = useMediaQuery()
  const imgProps = {
    alt: 'Premios',
    className: 'image  ',
  }
  if (isMobile) {
    return <img src={gifImg} {...imgProps} width={230} />
  }

  return <img src={gifImg} {...imgProps} width={299} />
}

function getGif() {
  try {
    const country = LOCALE.split('-')[1].toLowerCase()
    const result = useStaticQuery(
      graphql`      
        query GIF_PREMIOS_QUERY{
          photos: allFile(
            filter: {  
              relativePath: { regex: "/^premio.*\\.gif$/" } 
            }
          ) {
            edges {
              node { 
                relativePath,publicURL
              }
            }
          }
        } 
      
    `
    )
    const photos = result.photos.edges
      .map(edge => edge.node.publicURL)
      .filter(path => path.indexOf('-' + country) > -1)
    return photos[0] || ''
  } catch (error) {
    console.warn(e)
    return ''
  }
}
